import { render } from "./CurrentSelection.vue?vue&type=template&id=9690b814"
import script from "./CurrentSelection.vue?vue&type=script&lang=js"
export * from "./CurrentSelection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__